import React, { PureComponent } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { withRouter } from 'react-router';
import ObiLoadingFlat from './ObiLoadingFlat';

class RefreshPrompt extends PureComponent {
  render() {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <ObiLoadingFlat />
        <Typography align="center" variant="h5" gutterBottom={true}>
          Please refresh your browser
        </Typography>
        <Typography align="center" variant="body1" gutterBottom={true}>
          If issue persists please contact <a href="mailto:info@olympiabenefits.com">info@olympiabenefits.com</a>
        </Typography>
      </Grid>
    );
  }
}

export default withRouter(RefreshPrompt);
